import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { withSnackbar } from 'notistack';
import { Card, Tabs, Tab, CardContent, Box } from '@material-ui/core';
import TabPanel from '../../_shared/Tabs';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { IOrganizationService } from '../../../services/Interfaces/IOrganizationService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import { RoleClaimsEnum, RoleCodeEnum } from '../../../helpers/Constants';
import { OrganizationSupplierProducerDiscount } from '../../../interfaces/Organization';
import OrganizationSupplierProducerDiscounts from './OrganizationSupplierProducerDiscounts';
import OrganizationSuppliers from './OrganizationSuppliers';

interface IOrganizationSuppliersTabState {
  selectedTab: number;
}
class OrganizationSuppliersTab extends React.PureComponent<any, IOrganizationSuppliersTabState> {
  private translatorService!: ITranslatorService;
  private organizationService!: IOrganizationService;

  static contextType = ApplicationContext;

  state = { selectedTab: 0 };

  onTabChange = (event: any, newValue: number) => {
    this.setState({ selectedTab: newValue });
  };

  public hasRight = (right: string): boolean => {
    return this.props.appState!.user!.profile.role.includes(right);
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.organizationService = (this.context as AppContext).organizationService;

    return (
      <Fragment>
        <Box>
          <Card>
            <CardContent>
              <Tabs
                value={this.state.selectedTab}
                indicatorColor="primary"
                textColor="primary"
                variant="standard"
                onChange={this.onTabChange}
              >
                <Tab
                  className="text-capitalize "
                  label={this.translatorService.Tranlate('WORKFLOWS_TAB_SUPPLIERS', 'Furnizori')}
                />
                <Tab
                  className="text-capitalize "
                  label={this.translatorService.Tranlate(
                    'ORGANIZATION_SUPPLIERS_PRODUCER_DISCOUNTS',
                    'Discounturi Producatori furnizori'
                  )}
                />
              </Tabs>
            </CardContent>
          </Card>
        </Box>
        <TabPanel value={this.state.selectedTab} index={0}>
          <OrganizationSuppliers {...this.props} />
        </TabPanel>
        <TabPanel value={this.state.selectedTab} index={1}>
          <OrganizationSupplierProducerDiscounts {...this.props} />
        </TabPanel>
      </Fragment>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(OrganizationSuppliersTab as any));
